<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Informe</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-row style="margin-top: 1rem">
            <v-col cols="12" md="4"
                ><date-select
                    v-model="fecha_inicio"
                    label="Fecha de inicio"
                ></date-select
            ></v-col>
            <v-col cols="12" md="4"
                ><date-select
                    v-model="fecha_fin"
                    label="Fecha de fin"
                ></date-select
            ></v-col>
            <v-col cols="12" md="4"
                ><v-autocomplete
                    v-if="tab == 3"
                    v-model="agente"
                    :items="agentes"
                    item-text="nombre"
                    item-value="id"
                    label="Agente"
                ></v-autocomplete
            ></v-col>
            <v-col cols="12" md="2"
                ><v-btn
                    color="red"
                    class="white--text"
                    @click="
                        fecha_inicio = null;
                        fecha_fin = null;
                        agente = null;
                    "
                    >Limpiar</v-btn
                >
            </v-col>

            <v-col cols="12" md="2"
                ><v-btn color="primary" @click="getStats()">Filtrar</v-btn>
            </v-col>
        </v-row>
        <v-tabs v-model="tab">
            <v-tab>¿Cómo nos conocieron?</v-tab>
            <v-tab>Comercial</v-tab>
            <v-tab>Productos</v-tab>
            <v-tab>Estados</v-tab>
            <v-tab>Productos por comercial</v-tab>

            <!-- Como nos conocieron -->
            <v-tab-item
                ><v-row>
                    <v-col
                        cols="12"
                        style="
                            display: flex;
                            align-items: end;
                            justify-content: end;
                        "
                    >
                        <a
                            :href="`api/excel-informe-cliente?placeholder=null${this.getFechaRequest}`"
                            target="__blank"
                        >
                            <v-btn color="success">
                                <v-icon class="white--text"
                                    >mdi-file-excel</v-icon
                                >
                            </v-btn>
                        </a>
                    </v-col>
                    <v-col cols="12">
                        <v-data-table
                            dense
                            :headers="headers"
                            :items="data"
                            :items-per-page="-1"
                            item-key="id"
                            class="elevation-1"
                            :sort-by="['nombre']"
                            :sort-desc="[false]"
                        >
                        </v-data-table>
                    </v-col>
                    <v-col cols="12">
                        <apexchart
                            width="90%"
                            height="600"
                            type="bar"
                            :options="options"
                            :series="series"
                        ></apexchart>
                    </v-col>
                    <v-col cols="12">
                        <v-data-table
                            dense
                            :headers="headers"
                            :items="data_semanal"
                            :items-per-page="-1"
                            item-key="id"
                            class="elevation-1"
                            :sort-by="['nombre']"
                            :sort-desc="[false]"
                        >
                        </v-data-table>
                    </v-col> </v-row
            ></v-tab-item>

            <!-- Comercial -->
            <v-tab-item>
                <v-col
                    cols="12"
                    style="
                        display: flex;
                        align-items: end;
                        justify-content: end;
                    "
                >
                    <a
                        :href="`api/excel-informe-comerciales?placeholder=null${this.getFechaRequest}`"
                        target="__blank"
                    >
                        <v-btn color="success">
                            <v-icon class="white--text">mdi-file-excel</v-icon>
                        </v-btn>
                    </a>
                </v-col>
                <v-data-table
                    dense
                    :headers="headers_comercial"
                    :items="comerciales"
                    :items-per-page="-1"
                    item-key="id"
                    class="elevation-1"
                    :sort-by="['nombre']"
                    :sort-desc="[false]"
                    :item-class="
                        () => {
                            return 'pointer';
                        }
                    "
                    @click:row="
                        (item) => {
                            getComercialesDetalles(item.id_agente);
                        }
                    "
                >
                </v-data-table
            ></v-tab-item>

            <!-- Productos -->
            <v-tab-item
                ><v-row>
                    <v-col
                        cols="12"
                        style="
                            display: flex;
                            align-items: end;
                            justify-content: end;
                        "
                    >
                        <a
                            :href="`api/excel-cliente-producto?placeholder=null${this.getFechaRequest}`"
                            target="__blank"
                        >
                            <v-btn color="success">
                                <v-icon class="white--text"
                                    >mdi-file-excel</v-icon
                                >
                            </v-btn>
                        </a>
                    </v-col>
                    <v-col cols="12">
                        <v-data-table
                            dense
                            :headers="headers"
                            :items="data2"
                            :items-per-page="-1"
                            item-key="id"
                            class="elevation-1"
                            :sort-by="['nombre']"
                            :sort-desc="[false]"
                        >
                        </v-data-table>
                    </v-col>
                    <v-col cols="12">
                        <apexchart
                            width="90%"
                            height="600"
                            type="bar"
                            :options="options2"
                            :series="series2"
                        ></apexchart>
                    </v-col> </v-row
            ></v-tab-item>

            <!-- Estados -->
            <v-tab-item>
                <v-row>
                    <v-col
                        cols="12"
                        style="
                            display: flex;
                            align-items: end;
                            justify-content: end;
                        "
                    >
                        <a
                            :href="`api/excel-estado-potencial?placeholder=null${this.getFechaRequest}`"
                            target="__blank"
                        >
                            <v-btn color="success">
                                <v-icon class="white--text"
                                    >mdi-file-excel</v-icon
                                >
                            </v-btn>
                        </a>
                    </v-col>
                    <v-col cols="12">
                        <v-data-table
                            dense
                            :headers="headers_detalles"
                            :items="potenciales_estado"
                            :items-per-page="-1"
                            item-key="id"
                            class="elevation-1"
                            :sort-by="['nombre']"
                            :sort-desc="[false]"
                            :single-select="true"
                            v-model="estado"
                            show-select
                            @click:row="
                                (item) => {
                                    estado = [item];
                                }
                            "
                        >
                        </v-data-table>
                    </v-col>
                    <v-col cols="12">
                        <OnlyLista :filterString="getFechaRequest"></OnlyLista>
                    </v-col>
                </v-row>
            </v-tab-item>

            <!-- Productos por comercial -->
            <v-tab-item>
                <v-col
                    cols="12"
                    style="
                        display: flex;
                        align-items: end;
                        justify-content: end;
                    "
                >
                    <a
                        :href="`api/excel-informe-comerciales?placeholder=null${this.getFechaRequest}`"
                        target="__blank"
                    >
                        <v-btn color="success">
                            <v-icon class="white--text">mdi-file-excel</v-icon>
                        </v-btn>
                    </a>
                </v-col>
                <v-data-table
                    dense
                    :headers="headers_productos_comercial"
                    :items="productos_comercial"
                    :items-per-page="-1"
                    item-key="id"
                    class="elevation-1"
                    :sort-by="['nombre']"
                    :sort-desc="[false]"
                >
                </v-data-table>
            </v-tab-item>
        </v-tabs>

        <v-dialog v-model="comerciales_detalles_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Detalles
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                dense
                                :headers="headers_detalles"
                                :items="comerciales_detalles"
                                :items-per-page="-1"
                                item-key="id"
                                class="elevation-1"
                                :sort-by="['nombre']"
                                :sort-desc="[false]"
                            >
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import LineChart from "../componentes/line.vue";
import OnlyLista from "./OnlyLista.vue";
export default {
    components: {
        LineChart,
        OnlyLista,
    },
    data() {
        return {
            agente: null,
            potenciales_estado: [],
            data_semanal: [],
            tab: 0,
            options: {
                chart: {
                    id: "estadistica",
                },
                xaxis: {
                    categories: [],
                },
            },
            series: [
                {
                    name: "series-1",
                    data: [],
                },
            ],
            options2: {
                chart: {
                    id: "estadistica",
                },
                xaxis: {
                    categories: [],
                },
            },
            series2: [
                {
                    name: "series-1",
                    data: [],
                },
            ],
            fecha_inicio: null,
            fecha_fin: null,
            comerciales_detalles_dialog: false,
            comerciales_detalles: [],
            headers_detalles: [
                {
                    text: "Estado",
                    value: "estado",
                    sortable: false,
                },
                {
                    text: "Clientes",
                    value: "total",
                    sortable: false,
                },
                {
                    text: "Porcentaje",
                    value: "percent",
                    sortable: false,
                },
            ],
            headers: [
                {
                    text: "",
                    value: "nombre",
                    sortable: false,
                },
                {
                    text: "Unidades",
                    value: "peticiones_count",
                    sortable: false,
                },
                {
                    text: "Porcentaje",
                    value: "porcentaje",
                    sortable: false,
                },
            ],
            headers_comercial: [
                {
                    text: "Comercial",
                    value: "agente",
                    sortable: true,
                },
                {
                    text: "Total",
                    value: "total",
                    sortable: true,
                },
                {
                    text: "Empresa",
                    value: "empresa",
                    sortable: true,
                },
                {
                    text: "Propios",
                    value: "propios",
                    sortable: true,
                },
            ],
            headers_productos_comercial: [],
            productos_comercial: [],
            comerciales: [],
            data: [],
            labels: [],
            data2: [],
            labels2: [],
            dataset: [],
            estado: null,
        };
    },
    created() {
        this.rol = localStorage.getItem("role");
        this.fecha_inicio = this.getCurrentYearFormatted();
        this.getEstadisticas();
        this.getClientesSemanal();
        this.getAgentes();
    },
    watch: {
        estado(val) {
            console.log(val);
        },
        tab(val) {
            this.getStats();
        },
    },
    methods: {
        getCurrentYearFormatted() {
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear();
            const formattedString = `${currentYear}-01-01`;
            return formattedString;
        },

        clickRowEstado(estado) {
            console.log(estado);
        },
        getAgentes() {
            axios.get(`api/get-agentes`).then(
                (res) => {
                    this.agentes = [
                        ...[{ id: 0, nombre: "Sin Asignar" }],
                        ...res.data.Agentes,
                    ];
                },
                (res) => {}
            );
        },
        getStats() {
            const val = this.tab;
            if (val == 2) {
                this.getEstadisticasProducto();
            } else if (val < 2) {
                this.getEstadisticas();
                this.getClientesSemanal();
            } else if (val == 4) {
                this.getProductosComercial();
            } else {
                this.getPotencialesEstado();
            }
        },
        getEstadisticasProducto() {
            axios
                .get(
                    `/api/informe-cliente-producto?placeholder=null${this.getFechaRequest}`
                )
                .then((res) => {
                    this.data2 = res.data.data;
                    this.labels2 = res.data.labels;
                    this.options2 = {
                        colors: ["#851e31"],

                        chart: {
                            id: "estadistica",
                        },

                        xaxis: {
                            categories: this.labels2,
                            labels: {
                                maxHeight: 250, // Increase this value to allow more space for the text to grow
                                style: {
                                    fontSize: "10px",
                                    fontFamily: "Helvetica, Arial, sans-serif",
                                    fontWeight: "bold",
                                },
                            },
                        },
                    };
                    this.series2 = [
                        {
                            name: "Grafico 1",
                            data: res.data.values,
                        },
                    ];
                });
        },
        getEstadisticas() {
            axios
                .get(
                    `/api/informe-cliente?placeholder=null${this.getFechaRequest}`
                )
                .then((res) => {
                    this.data = res.data.data;
                    this.labels = res.data.labels;
                    this.options = {
                        colors: ["#851e31"],

                        chart: {
                            id: "estadistica",
                        },
                        style: {
                            fontSize: "10px",
                            fontFamily: "Helvetica, Arial, sans-serif",
                            fontWeight: "bold",
                        },
                        colors: ["#851e31"],
                        xaxis: {
                            categories: this.labels,
                            labels: {
                                style: {
                                    fontSize: "10px",
                                    fontFamily: "Helvetica, Arial, sans-serif",
                                    fontWeight: "bold",
                                },
                                maxHeight: 250, // Increase this value to allow more space for the text to grow
                            },
                        },
                    };
                    this.series = [
                        {
                            name: "Grafico 1",
                            data: res.data.values,
                        },
                    ];
                });
            this.getComerciales();
        },
        getComerciales() {
            axios
                .get(
                    `/api/informe-comerciales?placeholder=null${this.getFechaRequest}`
                )
                .then((res) => {
                    this.comerciales = res.data;
                });
        },
        getPotencialesEstado() {
            axios
                .get(
                    `/api/estadisticas-estado-potencial?placeholder=null${this.getFechaRequest}`
                )
                .then((res) => {
                    this.potenciales_estado = res.data;
                });
        },
        getComercialesDetalles(id) {
            axios
                .get(
                    `/api/informe-agente-estado?id=${id}${this.getFechaRequest}`
                )
                .then((res) => {
                    this.comerciales_detalles = res.data;
                    this.comerciales_detalles_dialog = true;
                });
        },
        getClientesSemanal() {
            axios
                .get(
                    `/api/informe-cliente-semanal?placeholder=null${this.getFechaRequest}`
                )
                .then((res) => {
                    this.data_semanal = res.data;
                });
        },

        getProductosComercial() {
            axios
                .get(
                    `/api/informe-productos-comercial?placeholder=null${this.getFechaRequest}`
                )
                .then((res) => {
                    console.log("data", res.data);
                    const response = res.data;

                    let headers = [
                        {
                            text: "Comercial",
                            value: "comercial",
                            sortable: false,
                        },
                    ];
                    response.productos.forEach((label) => {
                        headers.push({
                            text: label,
                            value: label,
                            sortable: false,
                        });
                    });

                    headers.push(
                        {
                            text: "Total",
                            value: "total",
                            sortable: false,
                        },
                        {
                            text: "Total sin Lumon",
                            value: "total_sin_lumon",
                            sortable: false,
                        }
                    );

                    this.headers_productos_comercial = headers;
                    this.productos_comercial = response.data;
                });
        },
    },
    filters: {},

    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
        getFechaRequest() {
            let str = "";

            if (this.fecha_inicio != null) {
                str += `&fecha_inicio=${this.fecha_inicio}`;
            }
            if (this.fecha_fin != null) {
                str += `&fecha_fin=${this.fecha_fin}`;
            }
            if (this.agente != null) {
                str += `&agente=${this.agente}`;
            }
            if (this.estado != null) {
                if (this.estado.length > 0) {
                    str += `&estado=${this.estado[0].id}`;
                }
            }
            return str;
        },
    },
};
</script>
